/*
 * Page store — browse + add/remove from all bundled classroom pages.
 * Same registry the live tab strip walks; this UI is the place where
 * teachers manage which pages their kids see in morning meeting.
 */

.body {
  display: flex;
  flex-direction: column;
  gap: 14px;
  font-family: var(--token-font-body);
}

.hint {
  margin: 0;
  font-size: 13px;
  color: rgba(28, 38, 32, 0.7);
  line-height: 1.4;
}

.grid {
  display: grid;
  /* Explicit column count (set by the component from item count) so the
   * fit-content dialog hugs the grid — narrow for one page, capped for
   * many — instead of stranding content in a fixed-width box. */
  grid-template-columns: repeat(var(--cols, 1), minmax(220px, 280px));
  justify-content: center;
  gap: 14px;
  padding: 4px 4px 8px;
}

.tile {
  position: relative;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 6px;
  padding: 14px 14px 12px;
  background: rgba(255, 255, 255, 0.62);
  border: 1.5px solid rgba(28, 38, 32, 0.12);
  border-radius: 14px;
  cursor: pointer;
  font-family: inherit;
  text-align: left;
  transition:
    transform 120ms ease,
    border-color 120ms ease,
    background 120ms ease,
    box-shadow 120ms ease;
}

.tile:hover {
  background: rgba(255, 255, 255, 0.92);
  transform: translateY(-1px);
}

.tileOn {
  border-color: var(--token-accent);
  box-shadow: 0 0 0 3px color-mix(in srgb, var(--token-accent) 18%, transparent);
}

.row {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
}

.glyph {
  font-size: 28px;
  line-height: 1;
  flex-shrink: 0;
}

.label {
  font-family: var(--token-font-display);
  font-size: 18px;
  color: var(--token-text-primary);
  margin: 0;
  flex: 1;
}

.blurb {
  font-family: var(--token-font-body);
  font-size: 12px;
  color: rgba(28, 38, 32, 0.7);
  line-height: 1.35;
  margin: 0;
}

.statePill {
  align-self: flex-end;
  padding: 3px 10px;
  border-radius: 999px;
  background: rgba(28, 38, 32, 0.08);
  font-family: var(--token-font-ui);
  font-size: 11px;
  font-weight: 600;
  letter-spacing: 0.3px;
  color: rgba(28, 38, 32, 0.7);
}

.tileOn .statePill {
  background: var(--token-accent);
  color: #fff;
}

.empty {
  margin: 0;
  font-size: 14px;
  color: rgba(28, 38, 32, 0.65);
  font-style: italic;
  padding: 24px 8px;
  text-align: center;
}
